export enum GridFilterFieldEntities {
  PROJECT = 'project',
  PROJECT_COUNTRY = 'project-country',
  CREATOR = 'creator',
  INTEGRATOR = 'integrator',
  REGION = 'region',
  BUSINESS_LOGIC = 'business-logic',
  PROJECT_END_USER_LEVEL = 'project-end-user-level',
  COMPONENT_TYPE = 'component-type',
  COMPONENT_MODEL = 'component-model',
  BRANCH_OFFICE = 'branch-office',
  LEGAL_ENTITY = 'legal-entity',
  WAREHOUSE_ITEM_TYPE = 'warehouse-item-type',
  WAREHOUSE_TYPE = 'warehouse-type',
  WAREHOUSE_MODEL = 'warehouse-model',
  UNIT_TYPE = 'unit-model',
  UNIT_MODEL = 'unit-model',
  UNIT_GROUP = 'unit-group',
  COMBINED_ROLE = 'combined-role',
  WEEKLY_SCHEDULE = 'weekly-schedule',
  UNIT_HW_MODEL = 'unit-hw-model',
  UNIT_COMMAND_NAME = 'unit-command-name'
}

export type GridFilterFieldEntity = typeof GridFilterFieldEntities[keyof typeof GridFilterFieldEntities];
